import { render, staticRenderFns } from "./ListaPedido.vue?vue&type=template&id=4c513f94&scoped=true"
import script from "./ListaPedido.vue?vue&type=script&lang=js"
export * from "./ListaPedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c513f94",
  null
  
)

export default component.exports